import Api from '../../api'
import { sgConfirm } from "../../plugins/SgAlert";
import AuthDialog from './AuthDialog';
import { showToast } from '../toast'

export const attachHandler = (element: HTMLElement) => {
  if (element.hasAttribute('data-remove-social')) {
    if ("paintWorklet" in CSS && !window.squircleInited) {
      window.squircleInited = true
      // noinspection JSIgnoredPromiseFromCall
      CSS.paintWorklet.addModule(
        "https://www.unpkg.com/css-houdini-squircle@0.2.2/squircle.min.js"
      );
    }
    element.addEventListener('click', removeSocialHandler(element))
    element.removeAttribute('data-remove-social')
  } else {
    element.addEventListener('click', async (event) => {
      event.preventDefault()
      event.stopPropagation()
      // noinspection ES6MissingAwait
      AuthDialog.show()
    })
  }

  let plugins = element.getAttribute('data-plugins').split(' ')
  plugins = plugins.filter((plugin) => plugin !== 'auth')
  if (plugins.length === 0) {
    element.removeAttribute('data-plugins')
  } else {
    element.setAttribute('data-plugins', plugins.join(' '))
  }
}

export const removeSocialHandler = (element: HTMLElement) => async () => {
  if (!await sgConfirm('Ты действительно хочешь отвязать данную социальную сеть от твоего аккаунта?')) {
    return
  }
  Api.post({
    url: 'auth/remove-social',
    body: {
      network: element.getAttribute('data-network'),
      id: element.getAttribute('data-id')
    }
  })
    .then(result => {
      if (!result.success) {
        showToast({
          type: 'error',
          text: 'Ошибка при отвязке социальной сети',
        })
        return
      }
      window.location.reload()
    })
}
